import { useQuery } from "@apollo/client"
import { LoadingIndicatorCentered } from "~/components/LoadingIndicator"
import { Error } from "~/ui/Error"
import { useParams } from "react-router-dom"
import invariant from "tiny-invariant"
import { TestQuestionResponsesList } from "~/tests/TestQuestionResponsesList"
import { PageHeader } from "~/ui/PageHeader"
import { adminQuestionResponsePath } from "~/common/paths"
import { CandidateTestLayout } from "~/layouts/CandidateTestLayout"
import { CANDIDATE_TEST_RESPONSES_QUERY_DOCUMENT } from "~/tests/candidateTestQueries"
import { Badge } from "~/shadcn/ui/badge"

export const AdminCandidateTestScreen = () => {
  const { candidateTestId } = useParams()
  invariant(candidateTestId)

  const { loading, data, error } = useQuery(
    CANDIDATE_TEST_RESPONSES_QUERY_DOCUMENT,
    {
      variables: {
        candidateTestId,
      },
    }
  )

  if (loading) return <LoadingIndicatorCentered />
  if (error || !data) return <Error message="Error loading response." />

  return (
    <div className="container mx-auto flex flex-col gap-8 mt-8 pb-12">
      <PageHeader
        title={`Test Response for ${data.candidateTest.test.name}`}
        subhead={`${data.candidateTest.test.organization.name}`}
      />
      <CandidateTestLayout
        test={data.candidateTest.test}
        candidateTest={data.candidateTest}
      >
        {(data.candidateTest.aiBio || data.candidateTest.aiSummary) && (
          <>
            <div className="flex flex-col gap-4 p-10 mb-4 border border-gray-E6E6E3 rounded-lg max-h-[300px] overflow-y-auto">
              {data.candidateTest.aiBio && (
                <div className="flex flex-col gap-2">
                  <div className="text-gray-999 text-lg font-medium">
                    Candidate Bio
                    <Badge className="ml-2" variant="default">
                      Beta
                    </Badge>
                  </div>
                  <div className="text-gray-333 text-base leading-7">
                    {data.candidateTest.aiBio}
                  </div>
                </div>
              )}
              {data.candidateTest.aiSummary && (
                <div className="flex flex-col gap-2">
                  <div className="text-gray-999 text-lg font-medium">
                    Test Summary
                    <Badge className="ml-2" variant="default">
                      Beta
                    </Badge>
                  </div>
                  <div className="text-gray-333 text-base leading-7">
                    {data.candidateTest.aiSummary}
                  </div>
                </div>
              )}
            </div>
            <h3 className="text-2xl">Candidate Responses</h3>
          </>
        )}
        <TestQuestionResponsesList
          data={data.candidateTestQuestionResponses.nodes}
          viewPath={(response) =>
            adminQuestionResponsePath({ questionResponseId: response.id })
          }
        />
      </CandidateTestLayout>
    </div>
  )
}
